import packageJson from '../../../package.json';
export const mpVersion = packageJson.version;